module.exports = __webpack_public_path__ + "OpenSource2.png?20996da5462d0a2b73de8d1b60f35eeb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/OpenSource2.png
// module id = 232
// module chunks = 0